/**
 * Copyright 2026, CS GROUP, https://www.cs-soprasteria.com/
 *
 * This file is part of AntFlow project.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import { AppRoutes } from '@/constants/routes';
import { Utils } from '@/utils/utils';
import { useQuery } from '@tanstack/react-query';
import { TriggerDetailView, useTriggers } from '@antflow-triggers-component';
import { Button } from 'primereact/button';
import React from 'react';
import { useNavigate, useParams } from 'react-router';

export const TriggerDetail: React.FC = () => {
  const { triggerId } = useParams();

  const navigate = useNavigate();

  const { triggerServiceInstance } = useTriggers();

  const { data } = useQuery({
    queryKey: ['triggerDetail', triggerId, triggerServiceInstance],
    queryFn: async () => {
      if (!triggerId) {
        throw new Error('No trigger ID provided');
      }
      return await triggerServiceInstance.getTrigger(parseInt(triggerId));
    }
  });

  const handleGotoProcess = (processPath?: string) => {
    if (!processPath) {
      return;
    }
    const ls = processPath.lastIndexOf('/processes/');
    const refProject = processPath.slice(0, ls).concat('/project');
    const process = processPath.split('/').toReversed()[0];
    let url = refProject;
    url = url.concat(
      Utils.buildNewQueryParamsUrl({
        tabs: '1',
        process_global: process
      })
    );
    navigate(url);
  };

  const handleBackToViewer = () => {
    navigate(AppRoutes.trigger.index.url());
  };

  return (
    <div className="p-4 w-full text-left">
      <div className="ml-5">
        <h2 className="">Trigger Detail</h2>
        <Button
          label="← Back to Triggers"
          size="small"
          onClick={handleBackToViewer}
          className="mb-4 p-button-secondary"
        />
      </div>
      {data && <TriggerDetailView handleGotoProcess={handleGotoProcess} trigger={data} />}
    </div>
  );
};
